const url = '/passengerEmail';
const Provider = 'PassengerEmail';
const dbModel = 'PassengerEmail';

export { url, Provider, dbModel };
